import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import CalloutCard from '../../../components/CalloutCard';
import Checkbox from '../../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../../components/Checkbox/CheckboxGroup';
import DefaultCard from '../../../components/DefaultCard';
import IconButton from '../../../components/IconButton/IconButton';
import Link from '../../../components/Link';
import ModalHeader from '../../../components/ModalHeader';
import PricingCalculatorCard, {
  PricingCardListItem,
} from '../../../components/PricingCalculatorCard';
import Radio, { RadioGroup } from '../../../components/Radio';
import SelectableCard from '../../../components/SelectableCard';
import { EnrollmentStore } from '../../../providers/enrollment';
import { getAllHealthSavings } from '../../../services/enrollment';
import {
  DateFormats,
  formatDate,
  openExternalLink,
} from '../../../utils/utils';

export type customHealthSavingsModalProps = {
  showHealthSavingsModal: boolean;
  handleCloseHealthSavingsModal: () => void;
};

const buttonForCalloutCard = [
  <Button
    variant="secondary-outline"
    rightIcon={light('calculator')}
    className="callout-button text-nowrap"
    size="sm"
    onClick={() =>
      openExternalLink(
        'https://qabtr.lifeatworkportal.com/dst/bw_hsalimitOE/?Disclaimer=0'
      )
    }
  >
    HSA Contribution Calculator
  </Button>,
];

const HealthSavingsModal = ({
  showHealthSavingsModal,
  handleCloseHealthSavingsModal,
}: customHealthSavingsModalProps) => {
  const [healthSavingData, setHealthSavingsData] = React.useState<any>({});
  const { activeHealthBenefits, updateCost, updatePlanName } =
    useContext(EnrollmentStore);
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const dataPlans = useMemo(() => {
    return getAllHealthSavings();
  }, []);

  useEffect(() => {
    if (dataPlans) {
      setHealthSavingsData(dataPlans);
      setListItems1([
        {
          text: `Your contributions in ${(new Date().getFullYear())} (est)`,
          value: dataPlans['plans'][0].selfAnnualContributions,
        },
        {
          text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
          value: dataPlans['plans'][0].companyAnnualContributions,
        },
      ]);
    }
  }, [dataPlans]);

  const [calculatorValue, setcalculatorValue] = React.useState<string | number>(
    1
  );

  useEffect(() => {
    const currentBenefit = activeHealthBenefits.find(
      (benefit: any) => benefit.type === 'health-savings'
    );
    const index = healthSavingData.plans?.findIndex(
      (plan: any) => plan.id === currentBenefit?.plan?.id
    );
    setcalculatorValue(index?.toString());
  }, [activeHealthBenefits, healthSavingData]);

  const [hsaAccountRadioValue, setHsaAccountRadioValue] = React.useState<
    string | number
  >(0);

  const [hsaAccountTransferRadioValue, setHsaAccountTransferRadioValue] =
    React.useState<string | number>(0);

  const [termsCheckboxValue, setTermsCheckboxValue] = React.useState<string[]>(
    []
  );

  const [hsaTerms, setHsaTerms] = React.useState<string[]>([]);

  const [listItems1, setListItems1] = useState<Array<PricingCardListItem>>([
    {
      text: `Your contributions in ${(new Date().getFullYear())} (est)`,
      value: 0,
    },
    {
      text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
      value: 1000,
    },
  ]);

  const [listItems2, setListItems2] = useState<Array<PricingCardListItem>>([
    {
      text: `Your contributions in ${(new Date().getFullYear())} (est)`,
      value: 0,
    },
    {
      text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
      value: 1000,
    },
  ]);

  const listItems3 = [
    {
      text: `Your contributions in ${(new Date().getFullYear())} (est)`,
      value: 525,
    },
    {
      text: `Company’s contributions in ${(new Date().getFullYear())} (est)`,
      value: 1000,
    }
  ];

  const [tellMeMore, setTellMeMore] = useState(false);

  const [showForm, setShowForm] = React.useState<boolean>(false);

  const handleInputValueChange = (
    value: number | undefined,
    listItems: Array<PricingCardListItem>,
    setListItems: Function
  ) => {
    let listItemsNew = listItems;
    if (listItemsNew[0]) {
      listItemsNew[0].value = value;
    } else {
      listItemsNew[0] = {
        text: '',
        value: value,
      };
    }
    setListItems(listItemsNew);
  };

  const handleCalculatorChange = (e: string | number) => {
    setcalculatorValue(e);
  };

  const handleChangeListItems = (value: number | undefined, index: number) => {
    if (index) {
      handleInputValueChange(value, listItems2, setListItems2);
    } else {
      handleInputValueChange(value, listItems1, setListItems1);
    }
  };

  const handleContinue = () => {
    if (calculatorValue === '3') {
      updateCost('health-savings', healthSavingData.plans[calculatorValue]);
      updatePlanName('health-savings', healthSavingData.plans[calculatorValue]);
      handleCloseHealthSavingsModal();
    } else if (calculatorValue !== '3' && !showForm) {
      setShowForm(true);
    } else {
      const items = calculatorValue === '0' ? listItems1 : calculatorValue === '1' ? listItems2 : listItems3;
      const newPlanCost = items.find((e) => e.text.includes('Your'));
      const currentPlan = healthSavingData.plans[calculatorValue];

      if (newPlanCost && newPlanCost.value) {
        currentPlan.cost = calculatorValue === '1' ? newPlanCost.value / 12 : newPlanCost.value;
      }

      updateCost('health-savings', currentPlan);
      updatePlanName('health-savings', currentPlan);
      handleCloseHealthSavingsModal();
    }
  };

  const handleHsaValueChange = (e: string | number) => {
    setHsaAccountRadioValue(e);
  };

  const handleHsaAccountTransferValueChange = (e: string | number) => {
    setHsaAccountTransferRadioValue(e);
  };

  const handleOnModalClose = () => {
    handleCloseHealthSavingsModal();
    setcalculatorValue('0');
    setHsaAccountRadioValue(0);
    setShowForm(false);
  };

  const handleOnTermsCheckboxValueChange = (event: any, values: string[]) => {
    setTermsCheckboxValue(values);
  };

  const handleOnHSATermsCheckboxValueChange = (
    event: any,
    values: string[]
  ) => {
    setHsaTerms(values);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  const handleTellMeMore = () => {
    setTellMeMore((prev) => !prev);
  };

  return (
    <>
      {healthSavingData ? (
        <Modal
          show={showHealthSavingsModal}
          onHide={handleCloseHealthSavingsModal}
          dialogClassName="modal-xl"
          className="custom-health-savings-modal"
        >
          <ModalHeader
            rightButton={
              <div onClick={toggleDetails} className={'icon-button-wrapper'}>
                <IconButton
                  variant="icon-default"
                  icon={light('circle-exclamation')}
                  extLabel="Benefit Info"
                />
              </div>
            }
          >
            <h4 className="text-sm-20-lg-32">
              {healthSavingData['generic']
                ? healthSavingData['generic']['title']
                : ''}
            </h4>
          </ModalHeader>
          <ModalBody>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="d-flex justify-content-center">
                <DefaultCard
                  closeButton={
                    <Link 
                      className='pt-0' 
                      isAlignAtEnd 
                      isWhiteIcon 
                      rightIcon={light('close')}
                      onClick={toggleDetails}
                    />                      
                  }
                  variant="blue-motif"
                  leftHeading={
                    healthSavingData['generic']
                      ? healthSavingData['generic']['info']['title']
                      : ''
                  }
                  leftSubheading={
                    <Container className={'px-0 d-flex flex-column'}>
                      {healthSavingData['generic'] ? (
                        <>
                          <span>
                            {healthSavingData['generic']['info']['description']}
                          </span>
                          {tellMeMore && (
                            <span className={'mt-1'}>
                              {healthSavingData['generic']['info'][
                                'additionalDescription'
                              ] &&
                                `The ${formatDate(
                                  new Date(),
                                  DateFormats.ONLY_YEAR
                                )} IRS maximum contribution is $3,500 for individuals or $7,000 for families. If you are age 55 or older, or turn age 55 anytime in ${formatDate(
                                  new Date(),
                                  DateFormats.ONLY_YEAR
                                )}, you can add an additional $1,000 contribution. If you have already made contributions to another HSA this year, you will need to factor that into your planned contributions below. Your total HSA contributions cannot exceed the annual limits.`}
                            </span>
                          )}
                        </>
                      ) : (
                        ''
                      )}
                    </Container>
                  }
                  button={
                    <Button
                      onClick={handleTellMeMore}
                      variant="primary-shadow"
                      size="sm"
                    >
                      {tellMeMore ? 'Tell me less' : 'Tell me more'}
                    </Button>
                  }
                  className={'mb-12'}
                />
              </div>
            </Row>
            <Container className="p-0">
              <Row className="mb-7 mb-lg-12">
                <Container className="d-flex justify-content-center">
                  <CalloutCard
                    cardIcon={light('screwdriver-wrench')}
                    buttons={buttonForCalloutCard}
                  >
                    <Row>
                      <span className="bolder-text text-ligther-grey">
                        Need help knowing how to contribute?
                      </span>
                      <p>
                        Use the{' '}
                        <span className="bolder-text text-ligther-grey">
                          HSA Contribution Calculator{' '}
                        </span>
                        to check what works best for you
                      </p>
                    </Row>
                  </CalloutCard>
                </Container>
              </Row>
              <RadioGroup
                name={'pricing-test1'}
                value={calculatorValue}
                onChange={handleCalculatorChange}
              >
                {dataPlans && dataPlans['plans'] ? dataPlans['plans'].map( (plan, index) => (
                  <Row className="pb-7">
                    {index !== 3 ? <PricingCalculatorCard
                      title={plan.title}
                      subtitle={
                        <div>
                          <div>{plan.subtitle1}</div>
                          {calculatorValue === index.toString() && plan.subtitle2 || ''}
                        </div>
                      }
                      radioButtonValue={index.toString()}
                      selected={calculatorValue === index.toString()}
                      radioButtonDefaultChecked={calculatorValue === index.toString()}
                      listItems={!index ? listItems1 : index === 1 ? listItems2 : listItems3}
                      isCollapsedView={calculatorValue !== index.toString()}
                      isPerPayPeriod={index !== 1}
                      minInputValue={index ? '100' : '1'}
                      maxInputValue={index ? '7300' : '525'}
                      disableNumberInputField={index === 2}
                      alwaysShowSubtitle={true}
                      handleChange={(value: number | undefined) => handleChangeListItems(value, index)}
                    />
                    : <PricingCalculatorCard
                        title="No Coverage"
                        subtitle={
                          <div>
                            <div>You could receive up to <b>$1,000</b> from your employer if sign up for a Health Savings Account!</div>
                          </div>
                        }
                        isCollapsedView={true}
                        disableNumberInputField={true}
                        listItems={[{text: '', value: 0}]}
                        radioButtonValue="3"
                        handleChange={() => {}}
                        selected={calculatorValue === '3'}
                        alwaysShowSubtitle={true}
                        disabled
                      />}
                  </Row>
                )) : ''}
              </RadioGroup>
              
            </Container>
          </ModalBody>
          <Modal.Footer className="pt-7">
            <Button
              onMouseDown={handleOnModalClose}
              className="text-nowrap mt-7 mt-lg-0"
              variant="primary-outline"
            >
              Cancel
            </Button>
            <Button
              onMouseDown={handleContinue}
              className="text-nowrap"
              variant="primary"
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        'NO DATA'
      )}
    </>
  );
};

export default HealthSavingsModal;
